// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"2a4e7230","79":"17766bec","114":"e5bc56ae","470":"a877b547","531":"c2bf0116","732":"7a322aa4"}[chunkId] + ".chunk.js";
};